import { Table, Typography } from 'antd'
import { FC, useMemo } from 'react'
import PrintQueueTableWrapper from '../../../../../../../components/print-queue-table/print-queue-table-wrapper'
import { getPrintQueueEntryRowClassName } from '../../../../../../machines-schedule/components/one-machine-schedule/helpers/print-job-helpers'
import { getColumns } from './columns'
import CustomRow from '../custom-row'
import { Zones } from '../../../../../../../types/api/print-queue-entry'
import { DocumentId, EndpointQueryParameters } from '../../../../../../../types/strapi/strapi'
import useRowsRefresh from '../../../../../../../hooks/table-pages/use-rows-refresh'
import { printQueueEntryAvailabilityRefreshPopulate } from '../../../../constants/print-queue-entry-refresh-populate'
import { useGetPrintQueueEntriesQuery } from '../../../../../../../store/api/print-queue-entries-api'
import { useHasRole } from '../../../../../../../hooks/use-has-role'
import { PRINT_PLAN_EDIT_ROLES } from '../../../../constants/print-plan-edit-roles'
import {
    materialRequirementsPopulate,
    shipmentAvailabilityPopulate,
    shipmentPeoplePopulate,
} from '../../../../constants/shipment-populate'

const initialQueryParams: EndpointQueryParameters = {
    filters: {
        zone: { $eq: Zones.Waiting },
    },
    populate: {
        print_job: {
            populate: {
                shipment: {
                    populate: {
                        ...shipmentAvailabilityPopulate,
                        ...shipmentPeoplePopulate,
                        client: true,
                        shipment_positions: true,
                        materialRequirements: { populate: materialRequirementsPopulate },
                        machine: true,
                        additional_machines: true,
                        calculated: true,
                        calculatedOnActual: true,
                    },
                },
            },
        },
        machine: true,
    },
}

interface MachineWaitingQueueProps {
    machineDocId: DocumentId
}

const MachineWaitingQueue: FC<MachineWaitingQueueProps> = ({ machineDocId }) => {
    const queryParams = useMemo(() => {
        const params = {
            ...initialQueryParams,
            filters: {
                ...initialQueryParams.filters,
                machine: { documentId: { $eq: machineDocId } },
            },
        }
        return params
    }, [machineDocId])

    const { data } = useGetPrintQueueEntriesQuery(queryParams)
    const dataSource = useRowsRefresh({
        rows: data?.data || [],
        useQuery: useGetPrintQueueEntriesQuery,
        fields: printQueueEntryAvailabilityRefreshPopulate.fields,
        populate: printQueueEntryAvailabilityRefreshPopulate.populate,
    })
    const canManagePrintPlan = useHasRole(PRINT_PLAN_EDIT_ROLES)
    const columns = useMemo(() => getColumns(canManagePrintPlan), [canManagePrintPlan])

    const filteredColumns = columns.filter(col => {
        if (col && 'dataIndex' in col && col.dataIndex === 'actions' && !canManagePrintPlan) {
            return false
        }
        return true
    })

    return (
        <>
            <Typography.Text strong>Ожидание</Typography.Text>
            <PrintQueueTableWrapper
                style={{ flex: 'auto', height: '100%', width: '100%' }}
                filtersSummaryHeight={0}
                tableHasNotPagination
            >
                <Table
                    dataSource={dataSource}
                    columns={filteredColumns}
                    pagination={false}
                    rowKey={'id'}
                    size={'small'}
                    components={{ body: { row: CustomRow } }}
                    rowClassName={getPrintQueueEntryRowClassName}
                />
            </PrintQueueTableWrapper>
        </>
    )
}

export default MachineWaitingQueue
